import Router from 'vue-router'
import main from '@/main.js'
import Vue from 'vue'
import layout from "@/layout/index.vue"

Vue.use(Router);

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    {
      path: '/',
      name: 'layout',
      component: layout,
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import('@/view/index.vue'),
          meta: { head: false, foot: false }
        }, {
          path: '/RouteList/',
          name: 'RouteListindex',
          component: () => import('@/view/RouterList.vue')
        }, {
          path: '/Template/Customized/',
          name: 'TemplateCustomized',
          component: () => import('@/view/Template/Customized.vue'),
          meta: {foot: false, head: true}
        }, {
          path: '/Product/Search/',
          name: 'productsearchindex',
          component: () => import('@/view/Product/Search/index.vue')
        }, {
          path: '/Product/Team/',
          name: 'productteamindex',
          component: () => import('@/view/Product/Team/index.vue')
        }, {
          path: '/Product/Team/GenerateWord.php',
          name: 'GenerateWordapp',
          component: () => import('@/view/Product/Team/GenerateWord.vue'),
          meta: {foot: false, head: false}
        }, {
          path: '/Template/About/',
          name: 'aboutindex',
          component: () => import('@/view/Template/about.vue'),
        },{
          path: '/Template/culture/',
          name: 'cultureindex',
          component: () => import('@/view/Template/culture.vue'),
        }
      ]
    }, {
      path: '*',
      component: () => import('@/errPage/404.vue'),
    }
  ]
});


let firstInit = true;

router.beforeResolve((to, from, next) => {
  main.$store.dispatch("Function/Auth/GetSession", {}).then(() => {
    if (firstInit) {
      firstInit = false;
      //
      main.$store.dispatch("app/checkHotKeyword", {});
    }

    next();
  });

  // });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js